<template>
  <div class="api-doc-container">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 20px;">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>通用ChatSDK与API接口文档</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 第一部分：通用ChatSDK参数说明 -->
    <el-card class="doc-section" shadow="never">
      <div class="section-title">1. 通用ChatSDK集成说明</div>
      <div class="desc">
        通用ChalSDK 即一个集成了chatAI中chatbot前端交互能力的javaScript库，便于其他平台快速通过悬浮窗口在自身应用上搭建客服聊天bot,通用的chalSDK需要开发者通过调整参数代码对名称、icon、头像、提示词、推荐问题等作自定义调整，并需传入chaUAPI访问授权。本平台chatbot管理页面可提供低可视化bot生成，并支持一健嵌入本平台chatWEB或复制代码快速嵌入三方平台中。可根据需要选择合适的应用方式。
          </div>
      <div class="sdk-row">
        <div class="sdk-img">
          <!-- 注意：图片路径需确保存在，否则页面会报错 -->
          <img src="../../assets/img/kef.png" alt="ChatSDK示意图" style="width: 40%; border-radius: 8px; box-shadow: 0 2px 8px #eee;">
        </div>
        <!-- <div class="sdk-params">
          <el-table
            :data="sdkParams"
            border
            style="width: 100%; margin-top: 16px;"
            size="small"
          >
            <el-table-column prop="name" label="参数名" width="120" />
            <el-table-column prop="type" label="类型" width="100" />
            <el-table-column prop="desc" label="说明" />
            <el-table-column prop="default" label="默认值" width="120" />
          </el-table>
        </div> -->
      </div>
    </el-card>

    <!-- 第二部分：API接口参数说明 -->
    <el-card class="doc-section" shadow="never" style="margin-top: 32px;">
      <div class="section-title">2. API接口参数说明</div>
      <div class="desc" style="margin-bottom: 12px;">
        您可以直接通过API调用chatAPI，实现文本和图片生成功能。图片生成API文档请参考：
        <a href="https://docs.siliconflow.cn/cn/api-reference/images/images-generations" target="_blank" style="color: #409EFF;">https://docs.siliconflow.cn/cn/api-reference/images/images-generations</a>
      </div>
      <el-descriptions title="API接口信息" :column="1" border>
        <el-descriptions-item label="接口地址">
          <span class="api-url">https://aae-api.scszsj.com/v1/chat-api/chat</span>
        </el-descriptions-item>
      </el-descriptions>
      <div class="sub-title">接口输入参数</div>
      <el-table
        :data="apiInputParams"
        border
        style="width: 100%; margin-bottom: 16px;"
        size="small"
      >
        <el-table-column prop="name" label="参数名" width="140" />
        <el-table-column prop="type" label="类型" width="100" />
        <el-table-column prop="required" label="必填" width="80" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
      <div class="sub-title">返回参数</div>
      <el-table
        :data="apiOutputParams"
        border
        style="width: 100%;"
        size="small"
      >
        <el-table-column prop="name" label="参数名" width="140" />
        <el-table-column prop="type" label="类型" width="100" />
        <el-table-column prop="desc" label="说明" />
      </el-table>
    </el-card>

    <!-- 机器人 -->
    <ChatWidget :config="config"></ChatWidget>
  </div>
</template>

<script>
import {chatBOTGet } from '../../api/userMG'
import ChatWidget from '../../components/ChatWidget'
export default {
  name: "ApiDoc",
  data() {
    return {
      config:{
      title: "智能客服",
      theme: "#F68020",
      welcome: "您好，我是智能助手，有什么可以帮您解答的问题？",
      avatar: "",
      logo:'',
      position: "right",
      recommendQuestions: ["实名认证多久通过？", "SDK使用手册"],
      isNetwork: false,
      isUpload: false,
      is_show:true,
      is_online:2,
      is_show_online:false,
      contact_content: "",
      api_key:'-YVjWGa_eq7gz802Xf2WiwVdZOxgW7qG6-02NzRB7VU',
    },
      // ChatSDK参数说明
      sdkParams: [
        { name: 'apiKey', type: 'string', desc: '用于鉴权的API密钥', default: '-' },
        { name: 'container', type: 'string/HTMLElement', desc: '挂载聊天窗口的DOM节点', default: 'body' },
        { name: 'theme', type: 'string', desc: '主题色（如 light/dark）', default: 'light' },
        { name: 'title', type: 'string', desc: '聊天窗口标题', default: '智能客服' },
        { name: 'avatar', type: 'string', desc: '机器人头像URL', default: '-' },
        { name: 'userAvatar', type: 'string', desc: '用户头像URL', default: '-' },
        { name: 'welcome', type: 'string', desc: '欢迎语', default: '您好，有什么可以帮您？' },
        { name: 'showClose', type: 'boolean', desc: '是否显示关闭按钮', default: 'true' },
        { name: 'customStyle', type: 'object', desc: '自定义样式', default: '{}' },
        { name: 'onMessage', type: 'function', desc: '消息回调函数', default: '-' },
      ],
      // API输入参数
      apiInputParams: [
        { name: 'Authorization', type: 'string', required: '是', desc: 'Authorization头是HTTP协议中用于身份验证的关键部分，组成为Authorization: Bearer api_key,api_key请于chatAPI复制获取。' },
        { name: 'query', type: 'string', required: '是', desc: ' 用户问题' },

      ],
      // API返回参数
      apiOutputParams: [
        { name: 'code', type: 'string', desc: '0' },
        { name: 'message', type: 'string', desc: 'success' },
        { name: 'data', type: 'array', desc: '返回正确的结果："answer": "为回复的结果",' },
        { name: 'detail', type: 'string', desc: '请求异常时的错误信息，根据实际返回显示错误信息' },
      ]
    }
  },
  components: {
    ChatWidget
  },
  created() {
    this.getchat()
  },
  methods: {
    getchat(){
      chatBOTGet(2)
        .then(res => {
          this.loading = false
          console.log(res,'chatBOTGetchatBOTGetchatBOTGetchatBOTGet')
          if (res.message == "success") {
              // 将十六进制颜色转换为RGB格式，便于--chat-bubble-color渲染
              this.config.theme = this.hexToRgb(res.data.theme_color);
              this.config.avatar =  res.data.icon;
              this.config.logo =  res.data.logo;
              this. config.title =  res.data.name;
              this.config.welcome =  res.data.welcome_speech;
              this.config.recommendQuestions =  res.data.recommended_question;
              if(res.data.customer_guidance=="on"){
                this.config.contact_content =  res.data.customer_guidance_text;
              }
              if(res.data.status=="normal"){
                this.config.is_show =  true;
              }
              //  this.config.api_key =  res.data.api_key;
              console.log(this.config,1111);
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    hexToRgb(hex) {
        // 移除可能存在的 # 符号
        hex = hex.replace(/^#/, '');
        // 处理缩写形式（如 #FFF => FFFFFF）
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        // 将十六进制分解为RGB分量
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `${r}, ${g}, ${b}`;
      },
    // 图片路径兼容处理，防止页面报错
    requireImg(fileName) {
      try {
        // 兼容webpack的require
        return require(`@/assets/${fileName}`)
      } catch (e) {
        // 如果图片不存在，返回空字符串或默认图片
        return ''
      }
    }
  }
}
</script>

<style scoped>
.api-doc-container {
  max-width: 100%;
  padding: 24px 0 40px 0;
}
.section-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 18px;
  color: #333;
}
.sub-title {
  font-size: 16px;
  font-weight: 500;
  margin: 18px 0 8px 0;
  color: #666;
}
.sdk-row {
  display: flex;
  align-items: flex-start;
  gap: 32px;
}
.sdk-img {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sdk-params {
  flex: 1;
}
.desc {
  color: #444;
  font-size: 15px;
  margin-bottom: 8px;
}
.api-url {
  color: #409EFF;
  font-family: monospace;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/api.vue